import {gql} from 'apollo-angular';

export const GET_ROOKIE_DAY_STUDENT_APPOINTMENTS = gql`
  query GetRookieDayStudentAppointments($code: String!, $verifyCode: String!) {
    rookiedayStudentAppointments(code: $code, verifyCode: $verifyCode) {
      startAt
      endAt
      companyName
      jobName
      contactFirstname
      contactLastname
    }
  }
`;
